module.exports = __webpack_public_path__ + "static/media/about-lrg.affbbecb.png";